import { obterPermissoesAsync,  obterPermissoesRegrasAsync, obterRegrasAsync } from "../../services/permissaoService";

const atualizarPermissoes = async ({ commit }) => {
    const permissoes = await obterPermissoesAsync();
    commit('atualizarPermissoes', permissoes);
}

const atualizarPermissoesRegras = async ({ commit }) => {
    const permissoesRegras = await obterPermissoesRegrasAsync();
    commit('atualizarPermissoesRegras', permissoesRegras);
}

const atualizarPermissao = ({ commit }, permissao) => {
    commit('atualizarPermissao', permissao);
}

const atualizarRegras = async ({ commit }) => {
    const regras = await obterRegrasAsync();
    commit('atualizarRegras', regras);
}

const atualizarRegra = ({ commit }, regra) => {
    commit('atualizarRegra', regra);
}

export default {
    atualizarPermissoes,
    atualizarPermissoesRegras,
    atualizarPermissao,
	atualizarRegras,
	atualizarRegra
}